import { ActionTypes as Action, Constants } from 'actions/shared/locale'
import { Locale } from 'types/Shared/Locale'

export const defaultState = {
  availableCountries: {},
  availableCurrencies: {},
  city: '',
  countryCode: '',
  countryConflict: false,
  regionCode: '',
  // selectedCurrency: null,
  // selectedLocale: null,
  serverResponse: {},
}
type State = Locale

const Reducer = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case Constants.SET_CURRENCY:
      return { ...state, selectedCurrency: action.payload, selectedLocale: action.payload.locale }

    case Constants.CHANGE_LOCALE:
      return { ...state, selectedLocale: action.payload }

    case Constants.UPDATE_LOCALE:
      return { ...state, ...(action.payload || {}) }

    default:
      return state
  }
}

export default Reducer
